// Settings
import settings from 'settings'

// Utils
import { api } from 'app/views/utils/api'


const GETTING_CONTENT = 'content/GETTING_CONTENT'
const RECEIVED_CONTENT = 'content/RECEIVED_CONTENT'

const GETTING_CONTENT_BY_ID = 'content/GETTING_CONTENT_BY_ID'
export const RECEIVED_CONTENT_BY_ID = 'content/RECEIVED_CONTENT_BY_ID'
const RECEIVED_CONTENT_BY_ID_ERROR = 'content/RECEIVED_CONTENT_BY_ID_ERROR'

const GETTING_LESSON_BY_ID = 'content/GETTING_LESSON_BY_ID'
const RECEIVED_LESSON_BY_ID = 'content/RECEIVED_LESSON_BY_ID'
const RECEIVED_LESSON_BY_ID_ERROR = 'content/RECEIVED_LESSON_BY_ID_ERROR'

const GETTING_PLAN = 'content/GETTING_PLAN'
const RECEIVED_PLAN = 'content/RECEIVED_PLAN'

const GETTING_VULNERABILITY_TYPES = 'content/GETTING_VULNERABILITY_TYPES'
const RECEIVED_VULNERABILITY_TYPES = 'content/RECEIVED_VULNERABILITY_TYPES'


const initialState = {
  loadingContent: false,
  content: {
    challenges: [],
    courses: [],
  },

  loadingContentById: false,
  loadingContentByIdError: '',
  contentDetails: {},

  loadingLessonById: false,
  loadingLessonByIdError: '',
  lessonDetails: {},

  loadingPlan: false,
  plan: {
    // uuid: null,
    // title: null,
    // description: null,
    // groups: [],
  },

  loadingVulnerabilityTypes: false,
  vulnerabilityTypes: [],
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GETTING_CONTENT:
      return {
        ...state,
        loadingContent: true,
      }
    case RECEIVED_CONTENT:
      return {
        ...state,
        content: action.content,
        loadingContent: false,
      }
    case GETTING_CONTENT_BY_ID:
      return {
        ...state,
        loadingContentById: true,
        loadingContentByIdError: '',
      }
    case RECEIVED_CONTENT_BY_ID:
      return {
        ...state,
        contentDetails: action.lessons,
        loadingContentById: false,
      }
    case RECEIVED_CONTENT_BY_ID_ERROR:
      return {
        ...state,
        loadingContentByIdError: action.error,
      }
    case GETTING_LESSON_BY_ID:
      return {
        ...state,
        loadingLessonById: true,
        loadingLessonByIdError: '',
      }
    case RECEIVED_LESSON_BY_ID:
      return {
        ...state,
        lessonDetails: action.lessons,
        loadingLessonById: false,
      }
    case RECEIVED_LESSON_BY_ID_ERROR:
      return {
        ...state,
        loadingLessonByIdError: action.error,
      }
    case GETTING_PLAN:
      return {
        ...state,
        loadingPlan: true,
      }
    case RECEIVED_PLAN:
      return {
        ...state,
        plan: action.plan,
        loadingPlan: false,
      }
    case GETTING_VULNERABILITY_TYPES:
      return {
        ...state,
        loadingVulnerabilityTypes: true,
      }
    case RECEIVED_VULNERABILITY_TYPES:
      return {
        ...state,
        vulnerabilityTypes: action.vulnerabilityTypes,
        loadingVulnerabilityTypes: false,
      }
    default:
      return state
  }
}

export function getLicenseContent(organizationUUID, licenseUUID) {
  return (dispatch, getState) => {
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/content`,
      idToken: state.auth.user.idToken,
      params: {
        license_type_uuid: licenseUUID,
        organization_uuid: organizationUUID,
      },
    })
  }
}

export function getContent(organizationUUID = null, includeAllOrganizationLicenses = null, callback = null) {
  return (dispatch, getState) => {
    dispatch({
      type: GETTING_CONTENT,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/content`,
      idToken: state.auth.user.idToken,
      params: {
        include_all_organization_licenses: includeAllOrganizationLicenses,
        organization_uuid: organizationUUID,
      },
    })
      .then((response) => {
        dispatch({
          type: RECEIVED_CONTENT,
          content: response.data,
        })
        if (callback) {
          callback()
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function pingContent(contentId) {
  return (dispatch, getState) => {
    const state = getState()
    if (contentId) {
      return api({
        method: 'post',
        url: `${settings.urls.hacker}/content/${contentId}/ping`,
        idToken: state.auth.user.idToken,
      })
        .catch((error) => {
          console.error({ error })
        })
    }
    return false
  }
}

export function getContentById(contentId) {
  return (dispatch, getState) => {
    dispatch({
      type: GETTING_CONTENT_BY_ID,
    })
    const state = getState()

    const language = (localStorage.getItem('hackedu.language') === null) ? 'en' : localStorage.getItem('hackedu.language')

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/content/${contentId}`,
      idToken: state.auth.user.idToken,
      params: {
        language,
      },
    })
      .then((response) => {
        dispatch({
          type: RECEIVED_CONTENT_BY_ID,
          lessons: {
            ...state.lessons,
            [contentId]: response.data,
          },
        })
      })
      .catch((error) => {
        if (error.response !== undefined && error.response.data.error === 'unauthorized') {
          dispatch({
            type: RECEIVED_CONTENT_BY_ID_ERROR,
            error: 'unauthorized',
          })
          return false
        }
        dispatch({
          type: RECEIVED_CONTENT_BY_ID_ERROR,
          error: 'error',
        })
        return false
      })
  }
}

export function getLessonById(lessonId) {
  return (dispatch, getState) => {
    dispatch({
      type: GETTING_LESSON_BY_ID,
    })
    const state = getState()

    const language = (localStorage.getItem('hackedu.language') === null) ? 'en' : localStorage.getItem('hackedu.language')

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/lesson/${lessonId}`,
      idToken: state.auth.user.idToken,
      params: {
        language,
      },
    })
      .then((response) => {
        dispatch({
          type: RECEIVED_LESSON_BY_ID,
          lessons: {
            ...state.lessons,
            [lessonId]: response.data,
          },
        })
      })
      .catch((error) => {
        console.error(error)
        if (error.response !== undefined && error.response.data.error === 'unauthorized') {
          dispatch({
            type: RECEIVED_LESSON_BY_ID_ERROR,
            error: 'unauthorized',
          })
          return false
        }
        dispatch({
          type: RECEIVED_LESSON_BY_ID_ERROR,
          error: 'error',
        })
        return false
      })
  }
}

export function getPlan() {
  return (dispatch, getState) => {
    dispatch({
      type: GETTING_PLAN,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/plan`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: RECEIVED_PLAN,
          plan: response.data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getVulnerabilityTypes() {
  return (dispatch, getState) => {
    dispatch({
      type: GETTING_VULNERABILITY_TYPES,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.hacker}/content-by-vulnerability`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: RECEIVED_VULNERABILITY_TYPES,
          vulnerabilityTypes: response.data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}
